
import Vue from 'vue'
import ProjectForm from '@/components/project/ProjectForm.vue'
import { Project } from '@/model/Project'
import { Multimedia } from '@/model/Multimedia'
import { Category } from '@/model/Category'
import { Tag } from '@/model/Tag'
import ProjectService from '@/service/ProjectService'

export default Vue.extend({
  name: 'ProjectNew',

  components: {
    ProjectForm,
  },

  mounted() {
    if (this.$store.state.authentication.signedIn) {
      if (
        this.$store.state.authentication.user.status === 'waiting_for_parent'
      ) {
        this.$store.dispatch(
          'alert/warning',
          "We are waiting for your parent's consent so you can't add new projects."
        )
        this.$router.push('/')

        return
      }
      this.$api
        .get(
          '/users/nickname/' + this.$store.state.authentication.user.nickname
        )
        .then((response) => (this.project.author = response.data))
    } else {
      this.$router.push('/sign-in')
    }
  },

  data: () => ({
    publishLoading: false,
    project: {
      id: '',
      name: '',
      author: null,
      mainImage: null,
      assets: [] as Multimedia[],
      description: '',
      content: '',
      status: 'in_progress',
      score: 5,
      createdAt: new Date().toISOString().substr(0, 10),
      startsAt: '',
      slug: '',
      category: null as string | null,
      tags: [] as Tag[],
      isDeleted: false,
      contestPlaces: [],
      applications: [],
      isFavourite: false
    } as Project,
  }),

  methods: {
    publishProject: function () {
      this.publishLoading = true

      this.$api
        .post('/projects', ProjectService.prepareDataToApi(this.project))
        .then((response: any) => {
          this.handleSuccess(response, (projectSlug) => {
            this.$router.push('/thank-you-for-sharing-your-project/' + projectSlug)
          });
        })
        .catch(this.handleErrors)
        .finally(() => (this.publishLoading = false))
    },
    handleSuccess: function(response: any, afterAddedCallback: (projectSlug: string) => void) {
      this.$store.dispatch(
        'alert/success',
        'Your project has been published!'
      )
      const projectSlug = (response.data as Project).slug

      if (this.$route.query.contest) {
        this.$router.push(
          '/contest/' +
            this.$route.query.contest +
            '?project=' +
            projectSlug
        )
        return
      }

      afterAddedCallback(projectSlug);
    },
    handleErrors: function(error: any) {
      let message = 'There are some problems with adding the project'

      if (error.response) {
        if ('hydra:description' in error.response.data) {
          message = error.response.data['hydra:description']
        } else {
          message += ' (' + error.response.status + ')'
        }
      }

      this.$store.dispatch('alert/error', message)
    }
  },
})
